<script setup lang="ts">
import { defineProps } from "vue";
import { defineEmits } from "vue";
import Spinner from "@/components/px-spinner/px-spinner.vue";

const props = defineProps<{
  title: string;
  query?: string;
  loading?: boolean;
  options: {
    component: any;
    props: any;
    listeners: any;
  }[];
  hasSearch?: boolean;
  searchPlaceholder?: string;
}>();

const emit = defineEmits(["updateQuery"]);
const updateQuery = (value: string) => {
  // @ts-expect-error fix type
  emit("update-query", value);
};

const clearAllFilters = () => {
  // @ts-expect-error fix type
  emit("clear-all-filters");
};
</script>

<template>
  <div class="facet-search-dropdown">
    <ElDropdown placement="bottom-start" :hide-on-click="false">
      <ElTag type="primary" effect="plain">{{ props.title }}</ElTag>
      <template #dropdown>
        <ElDropdownMenu>
          <ElInput
            v-if="props.hasSearch"
            clearable
            class="facet-search-dropdown__input"
            :model-value="props.query"
            :placeholder="props.searchPlaceholder"
            @input="updateQuery"
          />
          <ElDropdownItem
            v-for="option in props.options"
            :key="option.props.value"
          >
            <component
              :is="option.component"
              v-bind="option.props"
              v-on="option.listeners"
            />
          </ElDropdownItem>
          <div divider class="facet-search-dropdown__controls">
            <Spinner v-if="props.loading" />
            <ElTag type="danger" @click="clearAllFilters">Clear All</ElTag>
          </div>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
  </div>
</template>

<style lang="scss">
.facet-search-dropdown {
  &__input {
    margin: 8px auto 16px auto;
    padding: 0 10px;

    .el-input__inner {
      height: 28px !important;
      background-color: #fafafa;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  &__controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 16px;

    .el-tag {
      cursor: pointer;
      margin-left: auto;
    }
  }
}
</style>
